module.exports = __webpack_public_path__ + "img/bookings_blue.39d545c8.svg";